angular.module('picmonicng').factory('$browseStateParams', function () {
  return {};
});
